import React, { useState } from 'react';

import TabMenu from '@shared/searchBar/tabMenu';
import { RoomViewModel } from '@api/index';
import { Available, AvailableLimited } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { Col } from '@components/formStyles';
import palette from '@utils/theme/palette';

import { RoomFeatures } from './FeatureSetRenderers';
import {
  Legend,
  LegendItem,
  LegendTitle,
} from './DetailsGalleriesModalMobileStyles';
import RoomOptionDetails, {
  RoomOptionDetailProps,
} from '../RoomOptions/RoomOptionDetails';
import { SelectedVariationProps } from '../../context/types';
import {
  ReservationTypeText,
  RoomOptionsWrapper,
  TabMenuWrapper,
} from './styled';

export const ROOM_OPTIONS_TAB_MENU_LIST = [
  {
    id: 0,
    key: 'reservationType',
    text: 'Rezervasyon Tipi',
  },
  {
    id: 1,
    key: 'roomFeatures',
    text: 'Oda Özellikleri',
  },
];

interface Props {
  roomOptionDetailProps: RoomOptionDetailProps;
  openDatePicker(): void;
  onSelectDates?(): void;
  onSelectVariation(v: SelectedVariationProps): void;
  room?: RoomViewModel;
  features: Partial<{
    name: string;
    hasCharged: boolean;
    id: number;
  }>[];
}

const SelectVariationTab = ({
  openDatePicker,
  roomOptionDetailProps,
  onSelectDates,
  onSelectVariation,
  room,
  features,
}: Props) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = features.length
    ? ROOM_OPTIONS_TAB_MENU_LIST
    : ROOM_OPTIONS_TAB_MENU_LIST.filter((t) => t.id !== 1);

  return (
    <TabMenuWrapper>
      <TabMenu
        tabs={tabs}
        onTabChange={setSelectedTab}
        defaultTabId={0}
        colors={{
          passiveTextColor: palette.grey800,
        }}
      />
      {selectedTab === 0 ? (
        <RoomOptionsWrapper>
          <ReservationTypeText>Rezervasyon Tipini Seçiniz</ReservationTypeText>

          <RoomOptionDetails
            {...roomOptionDetailProps}
            openDatePicker={openDatePicker}
            onSelectDates={onSelectDates}
            handleSelectVariation={onSelectVariation}
          />
        </RoomOptionsWrapper>
      ) : (
        <Col>
          <Legend>
            <LegendItem>
              <Available />
              <LegendTitle>Ücretsiz olanaklar</LegendTitle>
            </LegendItem>
            <LegendItem>
              <CustomIcon
                icon={AvailableLimited}
                fontSize={24}
                paletteColor='fadedOrange'
              />
              <LegendTitle>Ücretli olanaklar</LegendTitle>
            </LegendItem>
          </Legend>

          <RoomOptionsWrapper>
            <RoomFeatures
              key='roomOptions'
              entityType='roomOptions'
              features={features}
              room={room}
              name=''
            />
          </RoomOptionsWrapper>
        </Col>
      )}
    </TabMenuWrapper>
  );
};

export default SelectVariationTab;
